module.exports = __webpack_public_path__ + "static/media/loading.c3cb5536.mp3";